import React from 'react';
import { Typography, TypographyProps } from '~ui-kit/components/typography';

export function PageTitle({ children, $mb }: TypographyProps<'h1'>) {
  return (
    <Typography
      component="h1"
      $fontFamily="Montserrat"
      $fontSize="32px"
      $fontWeight={500}
      $textAlign="center"
      $mb={$mb}
    >
      {children}
    </Typography>
  );
}
